<div class="forgot-shell">
  <div class="forgot-glow forgot-glow--pink"></div>
  <div class="forgot-glow forgot-glow--blue"></div>

  <div class="forgot-card">
    <section class="forgot-panel forgot-panel--visual">
      <video
        class="forgot-video"
        autoplay
        muted
        loop
        playsinline
        aria-label="Forgot Password Video"
      >
        <source
          src="https://sharajman.com/wp-content/uploads/2026/04/nea-login.mp4"
          type="video/mp4"
        />
      </video>

      <div class="forgot-overlay"></div>

      <div class="forgot-visual-content">
        <div class="forgot-pill">Nepal Electricity Authority</div>

        <div class="forgot-copy">
          <p class="forgot-copy__eyebrow">Need help?</p>
          <h1>Reset Password</h1>
          <p>
            Enter your email address and we will prepare the
            password reset flow for your account.
          </p>
        </div>
      </div>
    </section>

    <section class="forgot-panel forgot-panel--form">
      <div class="forgot-brand">
        <img [src]="logoPath" alt="Nepal Electricity Authority Logo" />
      </div>

      <div class="forgot-heading">
        <h2>Forgot Password</h2>
        <p>Enter your email and username if your email is used by more than one account</p>
      </div>

      <form class="forgot-form" [formGroup]="form" (ngSubmit)="sendMail()">
        <div class="field-group">
          <label for="username">Username</label>
          <input
            id="username"
            type="text"
            formControlName="username"
            placeholder="Enter username if needed"
            autocomplete="username"
          />
        </div>

        <div class="field-group">
          <label for="email">Email</label>
          <input
            id="email"
            type="email"
            formControlName="email"
            placeholder="Enter your email"
            autocomplete="email"
          />

          @if (form.get('email')?.touched && form.get('email')?.errors) {
            <div class="field-error">
              @if (form.get('email')?.errors?.['required']) {
                <span>Email is required</span>
              }
              @if (form.get('email')?.errors?.['email']) {
                <span>Enter a valid email address</span>
              }
            </div>
          }
        </div>

        @if (success) {
          <div class="message message--success">{{ success }}</div>
        }

        @if (error) {
          <div class="message message--error">{{ error }}</div>
        }

        <button type="submit" class="forgot-submit" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Sending...' : 'Send Mail' }}
        </button>

        @if (!canResend && resendCooldownSeconds > 0) {
          <div class="resend-hint">
            You can resend in {{ resendCooldownSeconds }}s
          </div>
        }

        @if (canResend && error) {
          <button type="button" class="forgot-submit forgot-submit--secondary" (click)="sendMail()">
            Resend Mail
          </button>
        }

        <div class="forgot-footer">
          <button type="button" class="link-button" (click)="goToSignin()">
            Go Back
          </button>
        </div>
      </form>
    </section>
  </div>
</div>
